<template>
  <div>
    <section>
      <altmetric-stats-bar></altmetric-stats-bar>
    </section>

    <section>
      <div class="title">
        Keywords
      </div>
      <div class="keywords"><em>{{keywordsFormatted}}</em></div>
    </section>

    <section>
      <div class="title">
        Article Tools
      </div>
      <div class="row">
        <div class="col-sm-6 col-md-12 col-xl-6 mb-2"><button class="button-primary btn-block" @click="getPdf()">Download PDF</button></div>
        <div class="col-sm-6 col-md-12 col-xl-6 mb-2"><button class="button-primary btn-block">How to Cite</button></div>
        <div class="col-sm-6 col-md-12 col-xl-6 mb-2"><button class="button-primary btn-block">Order a Reprint</button></div>
        <div class="col-sm-6 col-md-12 col-xl-6 mb-2"><button class="button-primary btn-block">Supplementals</button></div>
      </div>
    </section>

    <sidebar-signup-button></sidebar-signup-button>

  </div>
</template>

<script>
  import SidebarSignupButton from '@/components/main-layout/sidebar/SidebarSignUpButtonComponent'
  import AltmetricStatsBar from '@/components/main-layout/sidebar/AltmetricStatsBarComponent'
  export default {
    name: 'sidebar-article-section',
    components: {
      SidebarSignupButton,
      AltmetricStatsBar
    },
    data () {
      return {
        keywords: [],
        pdf: false
      }
    },
    props: ['article'],
    computed: {
      keywordsFormatted () {
        return this.keywords.join(', ')
      }
    },
    methods: {
      getPdf () {
        if (this.pdf) {
          location.href = this.pdf
        }
      }
    },
    mounted () {
      this.keywords = this.article.keywords
      if (this.article && this.article.files.pdf && this.article.files.pdf.display) {
        this.pdf = this.article.files.pdf.url
      }
    }
  }
</script>
<style scoped lang="scss">
  section {
    border-bottom: 1px solid $grey-border;
    margin: 20px 0;
    padding-bottom: 20px;
    .title {
      font-family: 'Merriweather';
      font-style: italic;
      color: $primary-color;
      font-size: 14px;
      margin-bottom: 15px;
    }
    .keywords {
      color: $secondary-color;
    }
  }
</style>



// WEBPACK FOOTER //
// SidebarArticleSectionComponent.vue?278b6e6d